export default __webpack_public_path__ + "static/screeny-55-gp-xs-3-1fea5e7a8a0206ac851ffdbc3e2caf80.jpg";